import { axios } from '@rmc/webcx-web-libs';
import { AxiosError, InternalAxiosRequestConfig } from 'axios';

type ResponseType = { mockData: unknown; config: unknown };

const getMockData = (
	config: InternalAxiosRequestConfig,
	mockKey: string | undefined
) => {
	if (!config || !config.url || !config.method || !mockKey) {
		return Promise.resolve(config);
	}

	const value = window?.[mockKey]?.[config.url]?.[config.method];

	if (!value) {
		return Promise.resolve(config);
	}

	const data = JSON.parse(value || 'null');

	const mockData = {
		mockData: data,
		config,
	};

	return Promise.reject(mockData);
};

const getMockResponse = (response: ResponseType | AxiosError) => {
	if (
		!response ||
		response instanceof AxiosError ||
		!response?.mockData ||
		!response?.config
	) {
		return Promise.reject(response);
	}

	return Promise.resolve({
		data: response.mockData,
		status: 200,
		statusText: 'OK',
		headers: {},
		config: response.config,
	});
};

export function setupInterceptors(mockKey: string) {
	axios.interceptors.request.use(
		(config: InternalAxiosRequestConfig) => getMockData(config, mockKey),
		(error) => error
	);

	axios.interceptors.response.use(
		(response) => response,
		(error) => getMockResponse(error)
	);

	return axios;
}
